<template>
  <div
    class="relative flex flex-col items-center bg-white rounded shadow-lg p-4"
  >
    <!-- title -->
    <!-- <div class="font-bold w-full">
      {{ $t("integrations.crm.giveCarlaAccess") }}
    </div> -->

    <!-- crm logo -->
    <img src="@/assets/icons/salesforce.png" class="w-56 mt-5" />

    <!-- Step 1 - Install salesforce package -->
    <!-- Description -->
    <div
      v-if="step === 2"
      v-html="$t('integrations.crm.salesforce.guide')"
      class="ml-10 mr-10"
    />

    <!-- sign in with salesforce -->
    <r-button
      v-if="step === 2"
      :loading="loading"
      id="sign-in-with-salesforce-button"
      text
      @click="continueWithSalesforce"
      class="flex item-center justify-center md:w-auto w-full mt-8"
    >
      <!-- icon -->
      <img src="@/assets/icons/salesforce.png" class="w-5 mr-2" />

      <!-- content -->
      <div>
        {{ $t("buttons.continueWithSalesforce") }}
      </div>
    </r-button>

    <!-- Step 2 - Sign in with salesforce -->
    <div
      v-if="step === 1"
      class="ml-10 mr-10"
      v-html="$t('integrations.crm.salesforce.releaiPackage')"
    />

    <!-- Next & Back buttons -->
    <div class="w-full flex flex-row mt-4">
      <div class="w-1/2">
        <r-button v-if="step === 2" @click="step = 1">
          {{ $t("buttons.back") }}
        </r-button>
      </div>
      <div class="w-1/2 flex justify-end">
        <r-button v-if="step === 1" @click="step = 2">
          {{ $t("buttons.next") }}
        </r-button>
      </div>
    </div>

    <!-- Close button - visible only om Mobile view -->
    <!-- <div class="md:hidden absolute bottom-0 right-0 mr-1 mb-1">
      <r-button color="black" text @click="$emit('close')">
        {{ $t("buttons.close") }}
      </r-button>
    </div> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import salesforceAPI from "@/api/salesforce"

export default {
  // local state
  data() {
    return {
      // set loading
      loading: false,

      // define step
      step: 1
    }
  },

  // define props
  props: {
    mode: {
      type: String,
      required: true
    }
  },

  // computed properties
  computed: {
    ...mapGetters({
      // map attributes
      jwt: "auth/getIdToken"
    })
  },

  // handle notification
  notifications: {
    notifyError: {
      type: "error"
    }
  },

  // methods
  methods: {
    /**
     * Signin with salesforce.
     */
    async continueWithSalesforce() {
      try {
        this.loading = true
        const api = new salesforceAPI(this.jwt)
        const { auth_url } = await api.notify("auth_url")
        location.replace(auth_url)
        this.loading = false
      } catch (e) {
        console.error(e)
        this.notifyError({
          title: this.$t("errors.unableToLoginWithSalesforce"),
          message: e.message
        })
      }
    }
  }
}
</script>
